import React from "react";
import {DragSourceMonitor, useDrag} from "react-dnd";

interface DynamicFieldTagProps {
    name: string;
    backendVariableName?: string;
}

// DRAG N DROP TAGS
export const DynamicFieldTagDnD: React.FC<DynamicFieldTagProps> = ({ name, backendVariableName = name }) => {
    const [{ isDragging }, dragRef] = useDrag({
        item: { fieldName: backendVariableName },
        type: "FIELD",
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        })
    });

    return (
        <span
            ref={el => {
                dragRef(el)
            }}
            className="dynamic-field-tag text-nowrap"
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: "grab",
                userSelect: "none"
            }}
        >
      <i className="fa-solid fa-lg opacity-50 fa-grip-vertical me-2" />
      <span>{name}</span>
    </span>
    );
};
